import {RouterModule, Routes} from '@angular/router';
import {Roles, SessionGuard} from './core/security';
import {LOGIN_COMPONENTS, LoginComponent} from './modules/login';
import {SPACE_COMPONENTS, SpaceComponent} from './modules/space';
import {ErrorComponent, UnauthorizedComponent} from './modules/error';
import {DashboardComponent} from './modules/dashboard';
import {BlankComponent} from './blank.component';
import {RolesGuard} from "./core/security/roles.guard";

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login'
    },

    {
        path: 'login',
        component: LoginComponent
    },

    {
        path: 'space',
        component: SpaceComponent,
        canActivate: [SessionGuard],
        canActivateChild: [SessionGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'accounts',
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },

            {
                path: 'applications',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/customers/+applications/applications.module')['ApplicationsModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },

            {
                path: 'customers',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/customers/+customers/customers.module')['CustomersModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },

            {
                path: 'accounts',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/+accounts/accounts.module')['AccountsModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },

            {
                path: 'transfers/outgoing',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/transfers/+outgoing/outgoing.transfers.module')['OutgoingTransfersModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },
            {
                path: 'cards',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/+cards/cards.module')['CardsModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },
            {
                path: 'transfers/card',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/transfers/+card/card.transfers.module')['CardTransfersModule']);  });}),
                canActivate: [RolesGuard.forRoles(Roles.EDIT)],
                canActivateChild: [RolesGuard.forRoles(Roles.EDIT)],
            },
            {
                path: 'history',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/+history/history.module')['HistoryModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },

            {
                path: 'crypto',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/+crypto/crypto.module')['CryptoModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },

            {
                path: 'open-banking',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/+open-banking/open-banking.module')['OpenBankingModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },

            {
                path: 'transfers/incoming',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/transfers/+incoming/incoming.transfers.module')['IncomingTransfersModule']);  });}),
                canActivate: [RolesGuard.forRoles(Roles.EDIT)],
                canActivateChild: [RolesGuard.forRoles(Roles.EDIT)],
            },

            {
                path: 'transfers/internal',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/transfers/+internal/internal.transfers.module')['InternalTransfersModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },
            {
                path: 'configuration',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/+configuration/configuration.module')['ConfigurationModule']);  });}),
                canActivate: [RolesGuard.forRoles(Roles.VIEW)],
                canActivateChild: [RolesGuard.forRoles(Roles.VIEW)],
            },

            {
                path: 'transfers/system',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/transfers/+system/system.transfer.module')['SystemTransferModule']);  });}),
                canActivate: [RolesGuard.forRoles(Roles.EDIT)],
                canActivateChild: [RolesGuard.forRoles(Roles.EDIT)],
            },

            {
                path: 'processing/external-orders',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/processing/+external-orders/payment-processing.module')['PaymentProcessingModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },

            {
                path: 'processing/manual-controls',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/processing/+manual-controls/manual-payment-controls.module')['ManualPaymentControlsModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },

            {
                path: 'reports',
                loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./modules/+reports/reports.module')['ReportsModule']);  });}),
                canActivate: [RolesGuard],
                canActivateChild: [RolesGuard],
            },
            {
                path: 'error',
                component: ErrorComponent
            },
            {
                path: 'unauthorized',
                component: UnauthorizedComponent
            }
        ]
    },

    {
        path: 'error',
        component: ErrorComponent
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent
    },
    {
        path: 'blank',
        component: BlankComponent
    }
];

export const ROUTER = RouterModule.forRoot(routes, {useHash: true});

export const ROUTER_COMPONENTS = [
    LoginComponent,
    SpaceComponent,
    ErrorComponent,
    UnauthorizedComponent,
    BlankComponent,
    DashboardComponent,
    ...LOGIN_COMPONENTS,
    ...SPACE_COMPONENTS
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/app.router.ts